export const getUniversityName = async () => {
    // Retrieve the current domain name
    const currentDomain = window.location.hostname;
    // Create a domain-to-University map

    const domainToUniversityMap = {
      
      'futuriss2.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_DIPANDA,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_DIPANDA,
      },
      'www.futuriss2.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_DIPANDA,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_DIPANDA,
      },

      'istaangola.com': { 
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ISTA,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_DIPANDA,
      },
      'www.istaangola.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ISTA,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_ISTA,
      },


      'siguc.ispozls.com': { 
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ISPOZLS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_ISPOZLSA,
      },
      'www.siguc.ispozls.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ISPOZLS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_ISPOZLSA,
      },

      'testesangola.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_FUTURISSTESTS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_FUTURISS_TESTS,
      },
      'www.testesangola.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_FUTURISSTESTS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_FUTURISS_TESTS,
      },

      'ucansoft.net': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_UCAN,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_UCAN,
      },
      'uwww.cansoft.net': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_UCAN,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_UCAN,
      },

      'futuriss.unikinrdc.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_UNIKINRDC,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_UNIKINRDC,
      },
      'www.futuriss.unikinrdc.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_UNIKINRDC,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_UNIKINRDC,
      },
      'futuriss.lecartesienrdc.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_LECARTESIEN,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_LECARTESIEN,
      },
      'www.futuriss.lecartesienrdc.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_LECARTESIEN,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_LECARTESIEN,
      },

      'futuriss.petitslutinsapp.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_PETISLUTINS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_PETISLUTINN,
      },
      'www.futuriss.petitslutinsapp.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_PETISLUTINS,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_PETISLUTINN,
      },

       
      'futuriss.ideroapp.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_IDERO,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_IDERO,
      },
      'www.futuriss.ideroapp.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_IDERO,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_IDERO,
      },

      'cum.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_CUM,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_CUM,
      },

      'futuriss.ispozangosede.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ISPOZANGOSEDE,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_ISPOZANGOSEDE,
      },

      'futuriss.sieraschools.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_SIERASCHOOL,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_SIERASCHOOL,
      },

      'ease.futurissvision.com': {
        abreviatura: process.env.NEXT_PUBLIC_UNIVERSITY_ABREVIATION_ESAE,
        nomUniversite: process.env.NEXT_PUBLIC_UNIVERSITY_ESAE
      },


    };
  
    // Check if the current domain is mapped to a University
    if (currentDomain in domainToUniversityMap) {
      const university = domainToUniversityMap[currentDomain];
      return {
        abreviatura: university.abreviatura,
        nomUniversite: university.nomUniversite,
      };
    } else {
      // Return default values or handle the case when the domain is not mapped
      return {
        abreviatura: '',
        nomUniversite: '',
      };
    }
  };
  